import formatLongDate from '@UI/Helpers/formatLongDate';
import { theme } from '@Guidelines/Theme/theme';
import type IdentityProviderView from '@UI/Store/Sso/Views/IdentityProviderView';
import { css } from '@emotion/react';
import * as React from 'react';
import { useSelector } from '@verclam/synapse';
import { Message } from '@verclam/ui-kit';

const testIdleStyle = css`
	margin: 0;
	padding: 1rem 1.125rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly identityProvider: IdentityProviderView | null;
};

/** Reports the outcome of the last connection test, read directly from the store. */
const ConnectionTestResult: React.FC<Props> = ({ identityProvider }) => {
	const connectionTest = useSelector((state) => state.ssoStore.connectionTest);

	return (
		<React.Fragment>
			{identityProvider !== null && connectionTest === null ? (
				<p css={testIdleStyle}>Aucun test lancé depuis la dernière modification.</p>
			) : null}
			{connectionTest !== null ? (
				<Message
					severity={connectionTest.succeeded ? 'success' : 'error'}
					text={`${connectionTest.message} (testé le ${formatLongDate(connectionTest.testedAt)})`}
				/>
			) : null}
		</React.Fragment>
	);
};

export default ConnectionTestResult;
